<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="hover">
      <div class="is-error-msg">
        {{ errorMsg }}
      </div>
      <el-checkbox-group v-if="checkList.length > 0"
          slot="reference"
          v-model="inputValue"
          :value="inputValue"
          :size="size"
          :disabled="disabled"
          :min="min"
          :max="max"
          :text-color="textColor"
          :fill="fill"
          @change="updateCheckedValue">
        <template v-if="button">
          <el-checkbox-button v-for="(data, index) in checkList"
              :key="index"
              :label="data[optionsLabelKey]"
              :true-label="data[optionsTrueLabelKey]"
              :false-label="data[optionsFalseLabelKey]"
              :disabled="data[optionsDisabledKey]"
              :checked="data[optionsCheckedKey]">
            {{ data[optionsViewLabelKey] }}
          </el-checkbox-button>
        </template>
        <template v-else>
          <el-checkbox v-for="(data, index) in checkList"
              :key="index"
              :label="data[optionsLabelKey]"
              :true-label="data[optionsTrueLabelKey]"
              :false-label="data[optionsFalseLabelKey]"
              :disabled="data[optionsDisabledKey]"
              :border="data[optionsBorderKey]"
              :size="data[optionsSizeKey]"
              :indeterminate="data[optionsIndeterminateKey]"
              :checked="data[optionsCheckedKey]">
            {{ data[optionsViewLabelKey] }}
          </el-checkbox>
        </template>
      </el-checkbox-group>
      <el-checkbox v-else
          ref="input"
          slot="reference"
          v-model="checked"
          :disabled="disabled"
          @change="onChange" />
    </el-popover>
    <div v-show="!popoverErrorMsg && errorMsg"
        class="is-error-msg">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import ValidCore from '@/components/atoms/BaseValidCore'

export default {
  name: 'BaseValidCheckbox',
  mixins: [ValidCore],
  props: {
    //  Attributes
    disabled: { type: Boolean, default: false },
    min: { type: Number, default: undefined },
    max: { type: Number, default: undefined },
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    fill: { type: String, default: undefined },
    textColor: { type: String, default: undefined },
    button: { type: Boolean, default: false },
    checkList: {
      type: Array,
      default: function () {
        return []
      }
    },
    optionsLabelKey: { type: String, default: 'code' },
    optionsViewLabelKey: { type: String, default: 'name' },
    optionsTrueLabelKey: { type: String, default: 'trueLabel' },
    optionsFalseLabelKey: { type: String, default: 'falseLabel' },
    optionsDisabledKey: { type: String, default: 'disabled' },
    optionsBorderKey: { type: String, default: 'border' },
    optionsSizeKey: { type: String, default: 'size' },
    optionsCheckedKey: { type: String, default: 'checked' },
    optionsIndeterminateKey: { type: String, default: 'indeterminate' }
    /*
    checkList = [{
      label: {},
      indeterminate: Boolean,
      disabled: Boolean,
      checked: Boolean,
      trueLabel: [String, Number],
      falseLabel: [String, Number],
      border: Boolean,
      size: String
    }, ...]
    */
  },
  computed: {
    checked: {
      get () {
        if (typeof this.inputValue === 'number') {
          return this.inputValue !== 0
        } else {
          return this.inputValue
        }
      },
      set (val) {
        // onChange で更新するためsetterは未実装
      }
    }
  },
  methods: {
    onChange (val) {
      let sendVal = typeof this.inputValue === 'number'
        ? val ? 1 : 0
        : val
      this.updateCheckedValue(sendVal)
    },
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.$el.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BaseValidCheckbox.vue